/* Lab Effects — shared FAQ accordion. Single-open, click a question to toggle.
   Mirrors the collection page behaviour (data-faq-item / data-faq-q). */
(function () {
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-faq-q]');
    if (!q) return;
    var item = q.closest('[data-faq-item]');
    if (!item) return;
    var scope = item.closest('[data-faq]') || document;
    var wasOpen = item.classList.contains('is-open');
    scope.querySelectorAll('[data-faq-item]').forEach(function (it) { it.classList.remove('is-open'); });
    if (!wasOpen) item.classList.add('is-open');
  });
})();
